module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/5rz0aTVbHu8qNr7bHDSPjy-61b2acd5d88f515060f0240cfd333f4c.jpg";